const UserUtils = (store, router) => {

    const loginUser = (val) => {
        if (val.account_info) { store.commit('user/setUser', val.account_info) };
    }

    const logoutUser = () => {
        store.commit('licenses/clearLicenses')
        store.commit('users/clearUsers')
        store.commit('user/clearUser')
        router.push({ path: `${!store.state.applicationWebView.isWebView ? '/login' : '/application/login'}` })
    }

    const userAccountCanBeDeleted = () => {
        // Check that the user is not ADMIN of a (cp2024) running license AND is not the linked user of a running license!
        const licenses = store.state.licenses.licenses
        const user = store.state.user.user
        const canNotBeDeleted = licenses.some((license) => {
            return license.current_status.activated && license.current_status.activeUser && ((license.admin.id == user.id) || (license.current_status.activeUser.id == user.id))
        })
        return !canNotBeDeleted
    }

    return {
        loginUser,
        logoutUser,
        userAccountCanBeDeleted
    };
}

export default UserUtils